import Icon from "./Icon";

/* setToast takes plain text from all over the app, so a failure is told by its words. */
const FAILURE =
  /fail|error|could ?n[o']t|cannot|can't|unable|invalid|not (allowed|found)|denied|too (large|big|long)|required|please|must|ვერ|შეცდომ|უნდა|გთხოვთ|არასწორ/i;

/*
  Figma "Toast": bg/overlay, radius/md, a 28 mark and a Subheadline Semibold message, centred
  over the bottom of the window and above the tab bar on phones and tablets.
*/
const Toast = ({ message, isDark, onDone }) => {
  const failed = FAILURE.test(message);
  return (
    <div
      data-theme={isDark ? "dark" : "light"}
      className="pointer-events-none fixed inset-x-space-16 bottom-[88px] z-[700] flex justify-center font-ds lg:bottom-space-32"
    >
      <div
        role="status"
        onAnimationEnd={onDone}
        className="flex min-h-[48px] max-w-full items-center gap-space-12 rounded-radius-md bg-bg-overlay px-space-12 py-[10px] text-label-primary shadow-overlay animate-toast"
      >
        <span
          className={`grid size-7 shrink-0 place-items-center rounded-radius-sm text-accent-on ${
            failed ? "bg-status-danger" : "bg-accent-default"
          }`}
        >
          <Icon name={failed ? "warning" : "check"} size={16} />
        </span>
        <span className="min-w-0 text-subheadline-semibold">{message}</span>
      </div>
    </div>
  );
};

export default Toast;
